import { Divider, Grid, IconButton, Paper, Typography } from "@mui/material"
import React from "react"
import WSSCheckBoxField from "../../Components/CheckBox/WSCheckBox"
import { WSIcons } from "../../commonFunctions/iIcons"
import { useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"

export const Accounting:React.FC<any>=React.memo((props)=>{
const { control, register, handleSubmit, setValue, reset, watch } = useForm();
    
    const navigate = useNavigate()
     const handleCancelClick = () => {
    navigate("/");
  };

    return(
           <Grid p={2}>
      <Paper sx={{ padding: 3, position: "relative" }} elevation={0}>
        {/* Close Icon in top right */}
        <IconButton
          size="small"
          sx={{ position: "absolute", top: 8, right: 8 }}
          onClick={handleCancelClick} // replace with your close logic
        >
          <WSIcons.CloseIcon fontSize="small" />
        </IconButton>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={4}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography fontWeight={"bold"}>Accounting</Typography>
                <Divider />
              </Grid>
              <Grid item xs={12}>
                <WSSCheckBoxField
                  label="Enable Accounting Module"
                  id="enableAccountingModule"
                  control={control}
                  {...register("enableAccountingModule")}
                  rules={{ required: false }}
                  name="enableAccountingModule"
                />
              </Grid>
              </Grid>
              </Grid>
              </Grid>
              </Paper>
              </Grid>
              
    )
})